import { useTranslation } from 'react-i18next';
import { PUBLIC_ROLES } from '@/mocks/dealer';
import { ROLE_DEFINITIONS } from '@/lib/roles';
import type { Role } from '@/types/domain';

const GROUP_ICONS: Record<string, string> = {
  customer: 'ri-user-line',
  dealer: 'ri-store-2-line',
  partner: 'ri-briefcase-line',
  admin: 'ri-shield-star-line',
};

export default function DealerRolesSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
            {t('dealer.rolesTitle')}
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t('dealer.rolesSubtitle')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PUBLIC_ROLES.map((role: Role, index) => {
            const def = ROLE_DEFINITIONS[role];
            return (
              <div
                key={role}
                className={`reveal flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-5 py-4 ${
                  index % 3 === 1 ? 'reveal-delay-1' : index % 3 === 2 ? 'reveal-delay-2' : ''
                }`}
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${GROUP_ICONS[def.group]} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="text-sm font-medium text-foreground-900">{t(def.labelKey)}</span>
              </div>
            );
          })}
        </div>

        <div className="reveal reveal-delay-1 mt-10 rounded-lg border border-primary-300/60 bg-primary-100/50 px-6 py-6 text-center">
          <h3 className="font-heading text-lg text-foreground-950">{t('dealer.termsTitle')}</h3>
          <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-foreground-700">
            {t('dealer.termsText')}
          </p>
        </div>
      </div>
    </section>
  );
}